import { render, staticRenderFns } from "./WindowStepper.vue?vue&type=template&id=2f85f73e"
import script from "./WindowStepper.vue?vue&type=script&lang=ts"
export * from "./WindowStepper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports